import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-shebeiguanli",
  "use": "icon-icon-shebeiguanli-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-shebeiguanli\"><path d=\"M225.088 786.752l45.12 18.816V501.44l-81.792 197.376a68.032 68.032 0 0 0 36.672 87.936z m656.832-124.672l-167.04-403.2a67.84 67.84 0 0 0-60.992-41.408 67.84 67.84 0 0 0-26.624 5.056L379.008 325.248a67.328 67.328 0 0 0-36.352 87.616l167.04 403.2a67.264 67.264 0 0 0 87.616 36.352l247.936-102.72a67.2 67.2 0 0 0 36.672-87.616z m-476.608-242.56a33.792 33.792 0 0 1-33.664-33.6c0-18.56 15.168-33.728 33.664-33.728a33.792 33.792 0 0 1 0 67.392z m-67.392 370.56c0 37.12 30.336 67.392 67.392 67.392h48.832L337.92 576.512v213.568z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-shebeiguanli.svg
// module id = TgAT
// module chunks = 3